import React from 'react';

import SavedSearchesBar from 'src/common/ui/SavedSearchesBar';

import { SearchState } from '../SearchPage';
import {
  useSavedSearches,
  MAX_SAVED_SEARCHES,
} from '../hooks/useSavedSearches';
import { useTranslation } from 'src/i18n/shim/useTranslation';

interface SavedSearchesBarProps {
  readonly onLoadSearch: (state: SearchState) => void;
}

/** Search page's saved search chips. Presentation lives in the shared bar. */
const SearchSavedSearchesBar: React.FC<SavedSearchesBarProps> = ({
  onLoadSearch,
}) => {
  const { t } = useTranslation();
  const { entries, remove } = useSavedSearches();

  return (
    <SavedSearchesBar<SearchState>
      entries={entries}
      remove={remove}
      onLoadSearch={onLoadSearch}
      label={t('search-saved-searches-label')}
      hint={t('search-saved-searches-hint', { max: MAX_SAVED_SEARCHES })}
      itemTestId="saved-search"
    />
  );
};

export default SearchSavedSearchesBar;
